import { useSelector } from 'react-redux';
import { selectHeaderConfig, selectMachinesHeaderConfig } from '@reducers/details';
import { useNavigationCheck } from '@v2/pages/machines/hooks/useNavigationCheck';

export const useGetHeaderConfig = () => {
  const { safeIsDetailsScreen } = useNavigationCheck();

  const detailsHeaderConfig = useSelector(selectHeaderConfig);
  const machinesHeaderConfig = useSelector(selectMachinesHeaderConfig);

  return safeIsDetailsScreen ? detailsHeaderConfig : machinesHeaderConfig;
};
